import type { ChartType } from '@/lib/types';

export function VisualSkeleton({ chartType }: { chartType: ChartType }) {
  switch (chartType) {
    case 'bar':    return <BarSkeleton />;
    case 'line':   return <LineSkeleton />;
    case 'kpi':    return <KpiSkeleton />;
    case 'matrix': return <MatrixSkeleton />;
    case 'card':   return <CardSkeleton />;
  }
}

function BarSkeleton() {
  const bars = [55, 78, 45, 92, 63, 80, 50, 70];
  return (
    <div className="w-full h-full px-3 pb-3 pt-4">
      <svg className="w-full h-full" viewBox={`0 0 ${bars.length * 26} 100`} preserveAspectRatio="none">
        <line x1="0" y1="100" x2={bars.length * 26} y2="100" stroke="#e2e8f0" strokeWidth="1" />
        {bars.map((h, i) => (
          <rect key={i} x={i * 26 + 2} y={100 - h} width={22} height={h} rx="2" fill="#e2e8f0" />
        ))}
      </svg>
    </div>
  );
}

function LineSkeleton() {
  return (
    <div className="w-full h-full px-3 py-3">
      <svg className="w-full h-full" viewBox="0 0 200 100" preserveAspectRatio="none">
        <line x1="0" y1="25"  x2="200" y2="25"  stroke="#e2e8f0" strokeWidth="1" />
        <line x1="0" y1="50"  x2="200" y2="50"  stroke="#e2e8f0" strokeWidth="1" />
        <line x1="0" y1="75"  x2="200" y2="75"  stroke="#e2e8f0" strokeWidth="1" />
        <line x1="0" y1="100" x2="200" y2="100" stroke="#e2e8f0" strokeWidth="1" />
        <polyline
          points="0,72 25,58 50,65 75,42 100,54 125,36 150,48 175,30 200,42"
          fill="none" stroke="#cbd5e1" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

function KpiSkeleton() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2.5 px-4">
      <div className="h-3 w-24 rounded-full bg-slate-200 animate-pulse" />
      <div className="h-10 w-32 rounded bg-slate-200 animate-pulse" />
      <div className="h-2.5 w-16 rounded-full bg-slate-200 animate-pulse" />
    </div>
  );
}

function MatrixSkeleton() {
  return (
    <div className="w-full h-full p-2 flex flex-col gap-0.5">
      <div className="h-6 rounded bg-slate-300 animate-pulse" />
      {[1, 2, 3, 4, 5].map(i => (
        <div
          key={i}
          className="h-5 rounded animate-pulse"
          style={{ backgroundColor: i % 2 === 0 ? '#f1f5f9' : '#f8fafc', animationDelay: `${i * 60}ms` }}
        />
      ))}
    </div>
  );
}

function CardSkeleton() {
  return (
    <div className="w-full h-full p-3 flex flex-col justify-center gap-2.5">
      {[1, 2, 3, 4].map(i => (
        <div key={i} className="flex gap-2 items-center" style={{ animationDelay: `${i * 60}ms` }}>
          <div className="h-4 flex-1 rounded bg-slate-200 animate-pulse" />
          <div className="h-4 w-14 rounded bg-slate-200 animate-pulse" />
        </div>
      ))}
    </div>
  );
}
